import { render, staticRenderFns } from "./FiltersAccordion.vue?vue&type=template&id=0cd06038&"
import script from "./FiltersAccordion.vue?vue&type=script&lang=js&"
export * from "./FiltersAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FiltersAccordion.vue?vue&type=style&index=0&id=0cd06038&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports